import { inject, Injectable } from '@angular/core';
import { AuthState, User } from '@auth0/auth0-angular';
import { filter, map, Observable, tap } from 'rxjs';
import { auth0Namespace, ClaimKeys, Organizations } from 'app/core/constants';

@Injectable({ providedIn: 'root' })
export class AuthStore {
  private readonly _authState = inject(AuthState);

  /**
   * Auth0 ID token claims.
   *
   * WARNING: `given_name` / `family_name` are NOT populated in Neer. The backend sets them only in
   * Auth0Service.CreateUserAsync, and self-service signup through Auth0 Universal Login never goes
   * through that path; UpdatePersonalInfoAsync writes SQL + DynamoDB but never syncs back to Auth0.
   * Reading them for display produces the literal string "undefined" (see SCRUM-894).
   * For a user's display name use UserApiClient.getCurrentUserName(), or the AppSync `username`.
   */
  readonly user$ = this._authState.user$;
  readonly userAvatar$ = this.user$.pipe(
    filter((u): u is User => u != null),
    map(u => u.picture!)
  );
  readonly userNameInitialism$ = this.user$.pipe(
    filter((u): u is User => u != null),
    map(u => (u.given_name?.[0] ?? '') + (u.family_name?.[0] ?? ''))
  );
  readonly organizationId$: Observable<string> = this.user$.pipe(
    map(u => u?.[ClaimKeys.app_metadata]?.['organization_id'])
  );

  constructor() {}
}
